












import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class PageSection extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop() readonly subtitle?: string;
}
